export const CREATE_EVENT = `
  mutation createEvent($input: CreateEventInput!, $tenant_id: Int!) {
    createEvent(input: $input, tenant_id: $tenant_id) {
      __typename

      ... on Event {
        id
        title
        campaign_id
        perma_link
        closing_date
        description
        location
        from_time
        to_time
        offer_contact
        offer_donate
        header
        banner
        offer_announce
        donation_header
        donation_footer
        custom_notification
        custom_subject
        custom_body
        hide_name
        do_not_validate
        do_not_ask_cuit
        do_not_show_company_fields
        poll_welcome_message
        require_donate
        organization
        do_not_show_company_fields_members
        hide_previous_checkbox
        attachics
        ics
        closed_url
        required_poll
        custom_account
        conditions
        success_message
        closed_message
        banner_h
        banner_v
        custom_css
        approve_terms
        terms
        generate_ics
        redirect_url
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_EVENT = `
  mutation updateEvent($input: UpdateEventInput!, $tenant_id: Int!) {
    updateEvent(input: $input, tenant_id: $tenant_id) {
      __typename

      ... on Event {
        id
        title
        campaign_id
        perma_link
        closing_date
        description
        location
        from_time
        to_time
        offer_contact
        offer_donate
        header
        banner
        offer_announce
        donation_header
        donation_footer
        custom_notification
        custom_subject
        custom_body
        hide_name
        do_not_validate
        do_not_ask_cuit
        do_not_show_company_fields
        poll_welcome_message
        require_donate
        organization
        do_not_show_company_fields_members
        hide_previous_checkbox
        attachics
        ics
        closed_url
        required_poll
        custom_account
        conditions
        success_message
        closed_message
        banner_h
        banner_v
        custom_css
        approve_terms
        terms
        generate_ics
        redirect_url
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_EVENT = `
  mutation deleteEvent($id: Int!, $tenant_id: Int!) {
    deleteEvent(id: $id, tenant_id: $tenant_id) {
      __typename

      ... on Event {
        id
        title
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
